import React from "react"
import PropTypes from "prop-types"
import scrollTo from "scroll-to-element"
 
export default class Sidebar extends React.Component {
 
  static propTypes = {
    specSelectors: PropTypes.object.isRequired,
  };
 
  onScroll = (tag) => {
    scrollTo(`#${tag}`, {
      offset: -5
    })
  }
 
  scrollToById = (elementId) => {
    var el = document.getElementById(elementId)
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' })
    }
  }
 
  handleScrollToSection = (tag, stateKey) => {
    this.setState({ [stateKey]: true }, () => {
      setTimeout(() => {
        const el = document.getElementById(tag);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    });
  };
 
  evaluateGetMethod = (path) => {
    if ((/.*\/{.*?/).test(path)) {
      return true
    } else {
      return false
    }
  }
 
  evaluatePostMethod = (path) => {
    if ((/bulk/g).test(path)) {
      return true
    } else {
      return false
    }
  }
 
  renderBasicsOfListSidebar(isInternal) {
    if (!isInternal) {
      return (<li><a onClick={() => this.onScroll('the_basics_of_list')}>The Basics of LIST</a></li>);
    }
    return null;
  }
 
  renderOAuthDemoSidebar() {
    return (<li><a href="/sso.html" target="_blank">Mineral Single Sign-On</a></li>);
  }
 
  renderReleaseNotesSidebar() {
    return (<li><a href="/releasenotes.html" target="_blank">Release Notes</a></li>);
  }
 
  renderMHRSidebar(isInternal) {
    if (!isInternal) {
      return (<li><a href="/mhrmigration.html" target="_blank">MHR API Bridge</a></li>);
    }
    return null;
  }
 
  render() {
 
    let {
      specSelectors,
      getConfigs
    } = this.props
 
    let taggedOps = specSelectors.taggedOperations()
 
    const {
      isInternal
    } = getConfigs()
 
    return (
      <div className="thr-sidebar">
        <h3 className="top-padding">Getting Started</h3>
        <ul>
          <li><a onClick={() => this.onScroll('welcome')}>Welcome</a></li>
          <li><a onClick={() => this.onScroll('security')}>Security</a></li>
          {this.renderBasicsOfListSidebar(isInternal)}
          <li><a onClick={() => this.onScroll('Postman')}>Postman Collection</a></li>
        </ul>
 
        <h3>API</h3>
        <ul>
          {
            taggedOps.map((tagObj, tag) => {
              let operations = tagObj.get("operations")
              let params = (new URL(window.location)).searchParams;
              const admintab = sessionStorage.getItem('showNav') === 'true';
              const isECI = tag.indexOf("Intelligence Core Library") !== -1
              const tagElementId = tag.replace(/\s+/g, '_')
              const tagLabel = tag === "Multi Client Admin Assignments" ? "Multi Client Admin" : tag
              return (
                <div key={tag}>
                  <li>
                  {
                      tag === "Mineral Embedded" ? (
                        <a onClick={() => this.onScroll("Mineral_Embedded")}>{tag}</a>
                      )
                      : tag === "Law Alerts" ? (
                       <a onClick={() => this.onScroll("Law_Alerts")}>{tag}</a>
                      )
                      : isECI ? (
                        <a onClick={() => this.scrollToById("Intelligence_Core_Library")}>{tag}</a>
                      )
                      :
                      (
                        <a onClick={() => this.onScroll(tagElementId)}>{tagLabel}</a>
                      )
                    }
                  </li>
                  <ul className="api-actions">
                    {
                      operations.map(op => {
                        const key_id = op.get("id", "")
                        const method = op.get("method", "")
                        const path = op.get("path", "")
                        const myOp = op.get("operation", "")
                        let betaFeatureFlag = params.get('beta');
                        if(!betaFeatureFlag && "Set Primary Location"==myOp.get("summary")){
                          return null
                        }
                        if (!admintab && "Deactivate Configuration" == myOp.get("summary")) {
                            return null
                        }
                        const summary = myOp ? (isECI ? myOp.get("summary", "") : myOp.get("summary", "").split(" ")[0]) : ""
                        const methodType = method === 'get' ? (this.evaluateGetMethod(path) === true ? 'one' : 'all') : (method === 'post' ? (this.evaluatePostMethod(path) === true ? 'bulk' : null) : null)
                        var methodLink
                        if (isECI) {
                          var summarySlug = myOp.get("summary", "").replace(/\s+/g, '_')
                          methodLink = tag.replace(/\s+/g, '_') + '-' + summarySlug
                        } else {
                          methodLink = methodType ? tagElementId + '-' + method.toUpperCase() + '-' + methodType.toUpperCase() : tagElementId + '-' + method.toUpperCase()
                        }
                        const methodLabel = summary ? (summary + ' (' + method.toUpperCase() + ')') : method.toUpperCase()
                        if (tag === "Law Alerts" || tag === "LAW_ALERTS") {
                          const sanitizedLink = methodLink.replace(/\s+/g, '_');
                          return (
                            <li key={key_id}>
                              <a onClick={() => this.onScroll(sanitizedLink)}>{methodLabel}</a>
                            </li>
                          )
                        }
                        if (isECI) {
                          return (
                            <li key={key_id}>
                              <a onClick={() => this.scrollToById(methodLink)}>{methodLabel}</a>
                            </li>
                          )
                        }
                        return (
                          <li key={key_id}>
                            <a onClick={() => this.onScroll(methodLink)}>{methodLabel}</a>
                          </li>
                        )
                      })
                    }
                    {isECI && (
                      <li>
                        <a onClick={() => this.onScroll('eci-quick-guide')}>Developer Hub Quick Setup Guide</a>
                      </li>
                    )}
                  </ul>
                </div>
              )
            })
          }
            </ul>
          <ul style={{ listStyleType: 'none', margin: 0, padding: 0 }}>
  <li style={{ margin: 0 }}>
    <a onClick={() => this.onScroll('mineralEmbedded')}>Mineral Embedded</a>
  </li>
  <ul style={{ listStyleType: 'none', paddingLeft: '12px', margin: 0 }}>
    <li style={{ margin: 0 }}>
      <a onClick={() => this.handleScrollToSection('mineral_embedded1','toggleInsightEventsAPI')}>Company-Insights (GET)</a>
    </li>
    <li style={{ margin: 0 }}>
      <a onClick={() => this.handleScrollToSection('mineral_embedded2','toggleInsightDetailsAPI')}>Insight-details (GET)</a>
    </li>
    <li style={{ margin: 0 }}>
      <a onClick={() => this.handleScrollToSection('mineral_embedded_webhook','showEmbeddedWebhookSection')}>Webhook-Insights</a>
    </li>
  </ul>
</ul>
 
        <h3>SSO</h3>
        <ul>
          {this.renderOAuthDemoSidebar()}
        </ul>
        <h3>Help / Support</h3>
        <ul>
          <li><a href='/developersupport.html' target='_blank'>Developer Support</a></li>
          {this.renderReleaseNotesSidebar()}
        </ul>
      </div>
    )
  }
}
 
Sidebar.propTypes = {
  specSelectors: PropTypes.object.isRequired,
}



// WEBPACK FOOTER //
// ./src/plugins/thinkhr/sidebar.jsx